<template>
	<v-menu
		:ref="menuLocal"
		v-model="menuLocal"
		:close-on-content-click="false"
		transition="scale-transition"
		offset-y
		max-width="290px"
		min-width="290px"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				v-model="dateLocal"
				:label="label"
				readonly
				v-bind="attrs"
				v-on="on"
				:disabled="disabled"
				@change="emitDate"
			></v-text-field>

		</template>
		<v-date-picker
			v-model="dateLocal"
			no-title
			:scrollable="scrollable"
			:first-day-of-week="1"
			:allowed-dates="allowedDates"
			@change="emitDate"
		/>
	</v-menu>
</template>

<script>
export default {
	name: 'DatePickerVue3',
	props: {
		rules: {
			type: Array,
		},
		label: {
			type: String,
		},
		scrollable: {
			type: Boolean,
			default: true,
		},
		setDateTodayMinusOneDay: {
			type: Boolean,
			default: false,
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			dateLocal: new Date().toISOString().substr(0, 10),
			menuLocal: false,
		}
	},
	methods: {
		allowedDates(val) {
			const d1 = new Date(val)
			const d2 = new Date()
			return d1 < d2
		},
		emitDate() {
			this.$emit('emitDate', this.dateLocal)
		},
		setFromTimeOnLoad() {
			if (this.setDateTodayMinusOneDay) {
				// sets from time to yesterday on page load, since the newest order is always from yesterday
				const dateYesterday = new Date(Date.now() - 864e5)
				const yearYesterday = dateYesterday.getFullYear()
				let monthYesterday = dateYesterday.getMonth() + 1
				let dayYesterday = dateYesterday.getDate()
				if (monthYesterday < 10) (monthYesterday = `0${monthYesterday.toString()}`)
				else monthYesterday = monthYesterday.toString()

				if (dayYesterday < 10) dayYesterday = `0${dayYesterday.toString()}`
				else dayYesterday = dayYesterday.toString()
				const yesterdayDate = `${yearYesterday.toString()}-${monthYesterday}-${dayYesterday}`
				this.dateLocal = yesterdayDate
				this.emitDate()
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.setFromTimeOnLoad()
		})
	},
}
</script>

<style>

</style>
